/* shop/AddProduct.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prop_dev,
	run_all,
	safe_not_equal,
	set_data_dev,
	set_input_value,
	space,
	text,
	to_number,
	validate_slots
} from "svelte/internal";

import basketStore from "./basketStore";
const file = "shop/AddProduct.svelte";

// (30:0) {#if print}
function create_if_block_1(ctx) {
	let input;
	let input_checked_value;
	let t0;
	let label;
	let span;
	let t5;
	let t6_value = (/*print*/ ctx[3].in_stock ? 'skladem' : 'není skladem') + "";
	let t6;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			input = element("input");
			t0 = space();
			label = element("label");
			span = element("span");
			span.textContent = `${/*print*/ ctx[3].binding}: ${/*print*/ ctx[3].unit_price} Kč`;
			t5 = space();
			t6 = text(t6_value);
			attr_dev(input, "type", "radio");
			attr_dev(input, "id", "type_print");
			input.checked = input_checked_value = /*selectedType*/ ctx[0] && /*selectedType*/ ctx[0] == /*print*/ ctx[3];
			attr_dev(input, "class", "radok");
			add_location(input, file, 30, 4, 666);
			add_location(span, file, 37, 8, 880);
			attr_dev(label, "for", "type_print");
			add_location(label, file, 36, 4, 847);
		},
		m: function mount(target, anchor) {
			insert_dev(target, input, anchor);
			insert_dev(target, t0, anchor);
			insert_dev(target, label, anchor);
			append_dev(label, span);
			append_dev(label, t5);
			append_dev(label, t6);

			if (!mounted) {
				dispose = listen_dev(input, "click", /*click_handler*/ ctx[5], false, false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*selectedType*/ 1 && input_checked_value !== (input_checked_value = /*selectedType*/ ctx[0] && /*selectedType*/ ctx[0] == /*print*/ ctx[3])) {
				prop_dev(input, "checked", input_checked_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(input);
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(label);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(30:0) {#if print}",
		ctx
	});

	return block;
}

// (46:0) {#if ebook}
function create_if_block(ctx) {
	let input;
	let input_checked_value;
	let t0;
	let label;
	let span;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			input = element("input");
			t0 = space();
			label = element("label");
			span = element("span");
			span.textContent = `e-kniha: ${/*ebook*/ ctx[4].unit_price} Kč`;
			attr_dev(input, "type", "radio");
			attr_dev(input, "id", "type_ebook");
			input.checked = input_checked_value = /*selectedType*/ ctx[0] && /*selectedType*/ ctx[0] == /*ebook*/ ctx[4];
			attr_dev(input, "class", "radok");
			add_location(input, file, 46, 4, 1075);
			add_location(span, file, 52, 28, 1280);
			attr_dev(label, "for", "type_ebook");
			add_location(label, file, 52, 4, 1256);
		},
		m: function mount(target, anchor) {
			insert_dev(target, input, anchor);
			insert_dev(target, t0, anchor);
			insert_dev(target, label, anchor);
			append_dev(label, span);

			if (!mounted) {
				dispose = listen_dev(input, "click", /*click_handler_1*/ ctx[6], false, false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*selectedType*/ 1 && input_checked_value !== (input_checked_value = /*selectedType*/ ctx[0] && /*selectedType*/ ctx[0] == /*ebook*/ ctx[4])) {
				prop_dev(input, "checked", input_checked_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(input);
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(label);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(46:0) {#if ebook}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let t0;
	let t1;
	let div2;
	let div0;
	let t2_value = /*price*/ ctx[2].toLocaleString() + "";
	let t2;
	let t3;
	let t4;
	let div1;
	let input;
	let t5;
	let button;
	let mounted;
	let dispose;
	let if_block0 = /*print*/ ctx[3] && create_if_block_1(ctx);
	let if_block1 = /*ebook*/ ctx[4] && create_if_block(ctx);

	const block = {
		c: function create() {
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			div2 = element("div");
			div0 = element("div");
			t2 = text(t2_value);
			t3 = text(" Kč");
			t4 = space();
			div1 = element("div");
			input = element("input");
			t5 = space();
			button = element("button");
			button.textContent = "do košíku";
			attr_dev(div0, "class", "book-shope--addToCart--price");
			add_location(div0, file, 58, 4, 1401);
			attr_dev(input, "type", "number");
			attr_dev(input, "min", "1");
			add_location(input, file, 60, 8, 1536);
			attr_dev(button, "type", "button");
			add_location(button, file, 61, 8, 1596);
			attr_dev(div1, "class", "book-shope--addToCart--addButton");
			add_location(div1, file, 59, 4, 1481);
			attr_dev(div2, "class", "book-shope--addToCart");
			add_location(div2, file, 57, 0, 1361);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert_dev(target, t0, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, div2, anchor);
			append_dev(div2, div0);
			append_dev(div0, t2);
			append_dev(div0, t3);
			append_dev(div2, t4);
			append_dev(div2, div1);
			append_dev(div1, input);
			set_input_value(input, /*quantity*/ ctx[1]);
			append_dev(div1, t5);
			append_dev(div1, button);

			if (!mounted) {
				dispose = [
					listen_dev(input, "input", /*input_input_handler*/ ctx[7]),
					listen_dev(button, "click", /*click_handler_2*/ ctx[8], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (/*print*/ ctx[3]) if_block0.p(ctx, dirty);
			if (/*ebook*/ ctx[4]) if_block1.p(ctx, dirty);
			if (dirty & /*price*/ 4 && t2_value !== (t2_value = /*price*/ ctx[2].toLocaleString() + "")) set_data_dev(t2, t2_value);

			if (dirty & /*quantity*/ 2 && to_number(input.value) !== /*quantity*/ ctx[1]) {
				set_input_value(input, /*quantity*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach_dev(t0);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(div2);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('AddProduct', slots, []);
	const dataElm = document.getElementById("addProduct");
	const data = JSON.parse(dataElm.dataset.addProduct);

	// jednotlive typy knihy
	const print = data.print ? data.print : null;

	const ebook = data.ebook ? data.ebook : null;

	// nastavitelne parametry
	let selectedType = print ? print : ebook;

	let quantity = 1;
	let price = 0;
	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<AddProduct> was created with unknown prop '${key}'`);
	});

	const click_handler = () => $$invalidate(0, selectedType = print);
	const click_handler_1 = () => $$invalidate(0, selectedType = ebook);

	function input_input_handler() {
		quantity = to_number(this.value);
		$$invalidate(1, quantity);
	}

	const click_handler_2 = () => basketStore.insertProduct(selectedType, quantity);

	$$self.$capture_state = () => ({
		basketStore,
		dataElm,
		data,
		print,
		ebook,
		selectedType,
		quantity,
		price
	});

	$$self.$inject_state = $$props => {
		if ('selectedType' in $$props) $$invalidate(0, selectedType = $$props.selectedType);
		if ('quantity' in $$props) $$invalidate(1, quantity = $$props.quantity);
		if ('price' in $$props) $$invalidate(2, price = $$props.price);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*quantity, selectedType*/ 3) {
			// vypocet ceny
			$: $$invalidate(2, price = quantity * selectedType.unit_price);
		}
	};

	return [
		selectedType,
		quantity,
		price,
		print,
		ebook,
		click_handler,
		click_handler_1,
		input_input_handler,
		click_handler_2
	];
}

class AddProduct extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "AddProduct",
			options,
			id: create_fragment.name
		});
	}
}

export default AddProduct;